var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',{staticStyle:{"vertical-align":"middle"},attrs:{"predefine":_vm.predefine},on:{"change":_vm.change},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})
}
var staticRenderFns = []

export { render, staticRenderFns }